/* NN Rent a Car – Core interactions
   - Off-canvas nav (overlay, ESC, focus restore, body scroll lock)
   - Swiper helper + testimonial / more-vehicles / vehicles-swiper ≤520px
   - FAQ parent module (search, accordion, sticky, hash)
   - FAQ single module (accordion, search, hash)
*/
(() => {
  "use strict";

  const qs = (s, el = document) => el.querySelector(s);
  const qsa = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* =========================
   * Header / Off-canvas Nav
   * ========================= */
  const header = qs('[data-js="header"]'); // nije obavezno, ali ne škodi
  const toggle = qs('[data-js="nav-toggle"]');
  const nav = qs('[data-js="primary-nav"]');
  const overlay = qs('[data-js="nav-overlay"]');
  const bpDesktop = window.matchMedia("(min-width: 992px)");

  let navOpen = false;
  let lastFocusedEl = null;

  function openNav() {
    if (navOpen || !nav) return;
    lastFocusedEl = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    document.body.classList.add("nav-open");
    nav.classList.add("is-open");
    overlay && overlay.classList.add("is-visible");
    if (toggle) {
      toggle.classList.add("open");
      toggle.setAttribute("aria-expanded", "true");
    }
    navOpen = true;

    // fokus na prvi link
    const firstLink = qs(".primary-nav__list a", nav);
    if (firstLink)
      try {
        firstLink.focus({ preventScroll: true });
      } catch (e) {}
  }

  function closeNav() {
    if (!navOpen || !nav) return;
    document.body.classList.remove("nav-open");
    nav.classList.remove("is-open");
    overlay && overlay.classList.remove("is-visible");
    if (toggle) {
      toggle.classList.remove("open");
      toggle.setAttribute("aria-expanded", "false");
    }
    navOpen = false;
    if (lastFocusedEl) {
      try {
        lastFocusedEl.focus({ preventScroll: true });
      } catch (e) {}
      lastFocusedEl = null;
    }
  }

  function toggleNav() {
    navOpen ? closeNav() : openNav();
  }

  // Toggler
  toggle &&
    toggle.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        toggleNav();
      },
      { passive: false }
    );

  // Blur on mousedown da ne ostaje focus ring
  toggle && toggle.addEventListener("mousedown", () => toggle.blur());

  // Overlay click
  overlay && overlay.addEventListener("click", closeNav);

  // ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && navOpen) closeNav();
  });

  // Na prelazak na desktop – zatvori panel
  const onBp = () => {
    if (bpDesktop.matches) closeNav();
  };
  if (bpDesktop.addEventListener) bpDesktop.addEventListener("change", onBp);
  else bpDesktop.addListener(onBp); // stariji Safari

  /* =========================
   * Swiper helpers + sliders
   * ========================= */
  const hasSwiper = () => typeof window.Swiper === "function";

  function initSwiperOnce(root, options) {
    if (!root || root.__swiperInit || !hasSwiper()) return null;
    const instance = new Swiper(root, options);
    root.__swiperInit = true;
    return instance;
  }

  // Vehicles swiper ≤520px – kreiraj/uništi po media query
  function vehiclesSwiperResponsive() {
    const el = document.querySelector(".vehicles-swiper.swiper");
    if (!el || !hasSwiper()) return;

    const mq = window.matchMedia("(max-width: 520px)");

    function ensure() {
      if (mq.matches) {
        if (!el.__swiperInstance) {
          el.__swiperInstance = new Swiper(el, {
            loop: true,
            speed: 500,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
            pagination: {
              el: el.querySelector(".swiper-pagination"),
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: 1,
            },
            lazy: { loadPrevNext: true },
            watchSlidesProgress: true,
            a11y: {
              enabled: true,
              prevSlideMessage: "Prethodno vozilo",
              nextSlideMessage: "Sledeće vozilo",
            },
          });
        }
      } else if (el.__swiperInstance) {
        el.__swiperInstance.destroy(true, true);
        el.__swiperInstance = null;
      }
    }

    ensure();
    if (mq.addEventListener) mq.addEventListener("change", ensure);
    else mq.addListener(ensure);
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Testimonial slider
    const tEl = qs(".testimonial-slider.swiper");
    initSwiperOnce(tEl, {
      loop: true,
      speed: 650,
      slidesPerView: 1,
      spaceBetween: 12,
      pagination: {
        el: tEl ? qs(".swiper-pagination", tEl) : null,
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      watchSlidesProgress: true,
      breakpoints: { 768: { spaceBetween: 16 }, 1024: { spaceBetween: 20 } },
    });

    // More vehicles (single-crbs_vehicle.php)
    const moreEl = qs(".more-vehicles__swiper");
    initSwiperOnce(moreEl, {
      loop: true,
      speed: 500,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      pagination: { el: ".more-vehicles .swiper-pagination", clickable: true, dynamicBullets: true },
      breakpoints: { 640: { slidesPerView: 2, spaceBetween: 20 }, 1024: { slidesPerView: 3, spaceBetween: 24 } },
      lazy: { loadPrevNext: true },
      a11y: { enabled: true, prevSlideMessage: "Prethodno vozilo", nextSlideMessage: "Sledeće vozilo" },
    });

    // Vehicles swiper ≤520px
    vehiclesSwiperResponsive();

    // Klik na hero sliku otvara prvu iz galerije (ako postoji)
    const heroLink = qs(".vehicle-figure__link");
    const firstThumb = qs(".galerio .gal-item");
    if (heroLink && firstThumb) {
      heroLink.addEventListener("click", (e) => {
        e.preventDefault();
        firstThumb.click();
      });
    }
  });
})();

/* ============================================================
 * FAQ parent page module (data-module="support-faq")
 * - accordion (bez max-height animacije)
 * - search + results panel
 * - sticky sidenav + active link
 * - hash open
 * ============================================================ */
(() => {
  "use strict";
  const root = document.querySelector('[data-module="support-faq"]');
  if (!root) return;

  const $$ = (sel, el = document) => Array.from(el.querySelectorAll(sel));

  /* Sidebar sticky (stop pre footera) */
  (function stickyAside() {
    const aside = root.querySelector(".support__nav");
    if (!aside) return;
    let inner = aside.querySelector(".support__nav-inner");
    if (!inner) {
      inner = document.createElement("div");
      inner.className = "support__nav-inner";
      while (aside.firstChild) inner.appendChild(aside.firstChild);
      aside.appendChild(inner);
    }
    const footer = document.querySelector("footer") || document.body.lastElementChild;
    if ("IntersectionObserver" in window && footer) {
      const stopObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => inner.classList.toggle("is-stopped", entry.isIntersecting));
        },
        { root: null, rootMargin: "0px 0px -24px 0px", threshold: 0 }
      );
      stopObserver.observe(footer);
    }
  })();

  /* Accordion (no max-height anim) */
  root.addEventListener("click", (e) => {
    const btn = e.target.closest(".ov-acc__head");
    if (!btn) return;

    const willOpen = !btn.classList.contains("is-open");
    const list = btn.closest(".ov-acc");

    $$(".ov-acc__head.is-open", list).forEach((b) => {
      if (b !== btn) {
        b.classList.remove("is-open");
        b.setAttribute("aria-expanded", "false");
      }
    });

    btn.classList.toggle("is-open", willOpen);
    btn.setAttribute("aria-expanded", willOpen ? "true" : "false");

    if (btn.id) history.replaceState(null, "", "#" + btn.id);
  });

  /* Search + results */
  const q = root.querySelector("#faq-search");
  const meta = root.querySelector("#faq-result-meta");
  let resultsBox = root.querySelector("#faq-results");

  if (!resultsBox) {
    resultsBox = document.createElement("div");
    resultsBox.id = "faq-results";
    resultsBox.className = "faq-results";
    resultsBox.setAttribute("aria-live", "polite");
    resultsBox.hidden = true;
    (meta?.parentNode || root.querySelector(".support__head") || root).appendChild(resultsBox);
  }

  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const hl = (text, term) => {
    if (!term) return text;
    const rx = new RegExp(escapeRegExp(term), "ig");
    return text.replace(rx, (m) => `<mark>${m}</mark>`);
  };
  const snippet = (ans, term) => {
    const max = 180;
    if (!ans) return "";
    if (!term) return ans.length > max ? ans.slice(0, max) + "…" : ans;
    const low = ans.toLowerCase();
    const pos = low.indexOf(term.toLowerCase());
    if (pos === -1) return ans.length > max ? ans.slice(0, max) + "…" : ans;
    const start = Math.max(0, pos - 60);
    const end = Math.min(ans.length, pos + 120);
    let frag = (start > 0 ? "…" : "") + ans.slice(start, end) + (end < ans.length ? "…" : "");
    return hl(frag, term);
  };

  const INDEX = [];
  $$(".ov-acc__head", root).forEach((head) => {
    const body = head.nextElementSibling;
    const section = head.closest(".faq-group");
    const groupTitle =
      section?.querySelector(".faq-group__title")?.textContent?.trim() || section?.querySelector("h2")?.textContent?.trim() || "";
    INDEX.push({
      id: head.id,
      q: head.textContent.trim(),
      a: (body.textContent || "").trim(),
      groupTitle,
    });
  });

  function ensureResultsHeader() {
    if (resultsBox.querySelector(".faq-results__head")) return;
    resultsBox.insertAdjacentHTML(
      "afterbegin",
      `
      <div class="faq-results__head">
        <div class="faq-results__title">Rezultati pretrage</div>
      </div>
      <div class="faq-results__list" role="listbox" aria-label="Rezultati"></div>
    `
    );
  }

  let activeIdx = -1;
  function setActive(idx) {
    const list = resultsBox.querySelector(".faq-results__list");
    const items = list ? $$(".faq-result", list) : [];
    items.forEach((el, i) => el.classList.toggle("is-active", i === idx));
    activeIdx = idx;
    if (idx >= 0 && items[idx]) items[idx].scrollIntoView({ block: "nearest" });
  }

  function renderResults(items, term) {
    ensureResultsHeader();
    const list = resultsBox.querySelector(".faq-results__list");

    if (!items.length) {
      list.innerHTML = `<div class="faq-result is-empty" role="option">
        <div class="faq-result__snippet">Nema rezultata.</div>
      </div>`;
      resultsBox.hidden = false;
      setActive(-1);
      return;
    }
    list.innerHTML = items
      .slice(0, 12)
      .map((it) => {
        const qHtml = hl(it.q, term);
        const snip = snippet(it.a, term);
        const meta = it.groupTitle ? `<span class="faq-result__meta"><span class="faq-chip">${it.groupTitle}</span></span>` : "";
        return `
        <div class="faq-result" data-id="${it.id}" role="option" aria-selected="false" tabindex="0">
          ${meta}
          <button class="faq-result__q" type="button">${qHtml}</button>
          <div class="faq-result__snippet">${snip}</div>
        </div>`;
      })
      .join("");
    resultsBox.hidden = false;
    setActive(0);
  }

  function openById(id) {
    const btn = document.getElementById(id);
    if (!btn || !btn.classList.contains("ov-acc__head")) return;
    const list = btn.closest(".ov-acc");
    $$(".ov-acc__head.is-open", list).forEach((b) => {
      if (b !== btn) {
        b.classList.remove("is-open");
        b.setAttribute("aria-expanded", "false");
      }
    });
    btn.classList.add("is-open");
    btn.setAttribute("aria-expanded", "true");
    history.replaceState(null, "", "#" + btn.id);
    btn.scrollIntoView({ behavior: "smooth", block: "start" });
    btn.focus?.();
  }

  const debounce = (fn, wait = 120) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), wait);
    };
  };

  function doSearch() {
    const input = q?.value.trim() || "";
    const term = input.toLowerCase();

    if (!term) {
      resultsBox.hidden = true;
      resultsBox.querySelector(".faq-results__list")?.replaceChildren();
      if (meta) meta.textContent = "";
      setActive(-1);
      return;
    }

    const hits = INDEX.map((it) => {
      const inQ = it.q.toLowerCase().includes(term);
      const inA = it.a.toLowerCase().includes(term);
      if (!inQ && !inA) return null;
      const score = (inQ ? 0 : 100) + (inA ? 10 : 0);
      return { ...it, score };
    })
      .filter(Boolean)
      .sort((a, b) => a.score - b.score);

    if (meta) meta.textContent = `Pronađeno stavki: ${hits.length}`;
    renderResults(hits, input);
  }

  if (q) {
    q.addEventListener("input", debounce(doSearch, 120));
    q.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        q.value = "";
        doSearch();
        return;
      }
      const list = resultsBox.querySelector(".faq-results__list");
      const items = list ? $$(".faq-result", list) : [];
      if (resultsBox.hidden || !items.length) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActive(Math.min(activeIdx + 1, items.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActive(Math.max(activeIdx - 1, 0));
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (activeIdx >= 0) items[activeIdx].click();
      }
    });
  }

  resultsBox.addEventListener("click", (e) => {
    const card = e.target.closest(".faq-result");
    if (!card) return;
    const id = card.getAttribute("data-id");
    if (id) openById(id);
  });
  resultsBox.addEventListener("keydown", (e) => {
    const card = e.target.closest(".faq-result");
    if (!card) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      const id = card.getAttribute("data-id");
      if (id) openById(id);
    }
  });

  // sticky sidenav active
  const navLinks = $$("#faq-nav a", root);
  const map = new Map(navLinks.map((a) => [a.getAttribute("href"), a]));
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = "#" + entry.target.id;
        const link = map.get(id);
        if (!link) return;
        if (entry.isIntersecting) {
          navLinks.forEach((a) => a.classList.toggle("is-active", a === link));
          history.replaceState(null, "", id);
        }
      });
    },
    { rootMargin: "-120px 0px -70% 0px", threshold: 0.01 }
  );
  $$(".faq-group", root).forEach((sec) => io.observe(sec));

  // smooth scroll u sidenav
  root.querySelector("#faq-nav")?.addEventListener("click", (e) => {
    const a = e.target.closest("a");
    if (!a) return;
    const id = a.getAttribute("href");
    if (!id || !id.startsWith("#")) return;
    const target = root.querySelector(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  // open by hash
  window.addEventListener("DOMContentLoaded", () => {
    const id = location.hash.replace("#", "");
    if (!id) return;
    const btn = document.getElementById(id);
    if (btn && btn.classList.contains("ov-acc__head")) {
      btn.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
      btn.scrollIntoView({ block: "start", behavior: "smooth" });
      btn.focus?.();
    }
  });
})();

/* ============================================================
 * FAQ single module (data-module="support-faq-single")
 * ============================================================ */
(() => {
  "use strict";
  const root = document.querySelector('[data-module="support-faq-single"]');
  if (!root) return;

  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  // Accordion sa max-height (kako si već imao)
  root.addEventListener("click", (e) => {
    const btn = e.target.closest(".ov-acc__head");
    if (!btn) return;
    const body = btn.nextElementSibling;
    const open = !btn.classList.contains("is-open");

    const list = btn.closest(".ov-acc");
    $$(".ov-acc__head.is-open", list).forEach((b) => {
      if (b !== btn) {
        b.classList.remove("is-open");
        b.setAttribute("aria-expanded", "false");
        b.nextElementSibling.style.maxHeight = null;
      }
    });

    btn.classList.toggle("is-open", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    body.style.maxHeight = open ? body.scrollHeight + "px" : null;
    if (btn.id) history.replaceState(null, "", "#" + btn.id);
  });

  // Lokalna pretraga
  const q = root.querySelector("#faq-search");
  const meta = root.querySelector("#faq-result-meta");
  if (q) {
    q.addEventListener("input", () => {
      const term = q.value.trim().toLowerCase();
      let cnt = 0;
      $$(".ov-acc__head", root).forEach((head) => {
        const body = head.nextElementSibling;
        const hay = (head.textContent + " " + (body.textContent || "")).toLowerCase();
        const ok = term ? hay.includes(term) : true;
        head.parentElement.style.display = ok ? "" : "none";
        if (ok) {
          cnt++;
          if (term) {
            head.classList.add("is-open");
            head.setAttribute("aria-expanded", "true");
            body.style.maxHeight = body.scrollHeight + "px";
          } else {
            head.classList.remove("is-open");
            head.setAttribute("aria-expanded", "false");
            body.style.maxHeight = null;
          }
        }
      });
      if (meta) meta.textContent = term ? `Pronađeno stavki: ${cnt}` : "";
    });
  }

  // Open by hash
  window.addEventListener("DOMContentLoaded", () => {
    const id = location.hash.slice(1);
    const btn = id ? document.getElementById(id) : null;
    if (!btn || !btn.classList.contains("ov-acc__head")) return;
    const body = btn.nextElementSibling;
    btn.classList.add("is-open");
    btn.setAttribute("aria-expanded", "true");
    body.style.maxHeight = body.scrollHeight + "px";
    btn.scrollIntoView({ behavior: "smooth", block: "start" });
    btn.focus?.();
  });
})();

/* ============================================================
 * NN Google Maps Loader (home + kontakt) – async + AdvancedMarker
 * ============================================================ */
(() => {
  "use strict";

  const cfg = window.NN_MAPS_DATA;
  const el  = document.getElementById("map");
  if (!cfg || !el) return;

  // Učitaj Google Maps sa loading=async (bez callback-a)
  function loadMaps() {
    return new Promise((resolve, reject) => {
      if (window.google?.maps) return resolve();
      const url = new URL("https://maps.googleapis.com/maps/api/js");
      url.searchParams.set("key", cfg.apiKey || "");
      url.searchParams.set("v", "weekly");
      url.searchParams.set("libraries", cfg.libraries || "marker"); // važno za AdvancedMarkerElement
      url.searchParams.set("language", cfg.language || "sr");
      url.searchParams.set("region", cfg.region || "RS");
      url.searchParams.set("loading", "async");

      const s = document.createElement("script");
      s.src = url.toString();
      s.async = true;
      s.defer = true;
      s.onerror = reject;
      s.onload = resolve;
      s.setAttribute("loading", "async");
      document.head.appendChild(s);
    });
  }

  async function init() {
    await loadMaps();
    await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    const markers = Array.isArray(cfg.markers) ? cfg.markers : [];
    if (!markers.length) return;

    const toNum = (v) => Number(v || 0);
    const avgLat = markers.reduce((a, m) => a + toNum(m.lat), 0) / markers.length;
    const avgLng = markers.reduce((a, m) => a + toNum(m.lng), 0) / markers.length;

    const map = new google.maps.Map(el, {
      center: { lat: avgLat, lng: avgLng },
      zoom: 12,
      gestureHandling: "cooperative",
      mapId: cfg.mapId || undefined
    });

    const info = new google.maps.InfoWindow();
    const bounds = new google.maps.LatLngBounds();

markers.forEach((m) => {
  const pos = { lat: toNum(m.lat), lng: toNum(m.lng) };
  const adv = new AdvancedMarkerElement({ map, position: pos, title: m.title || "" });
  bounds.extend(pos);

  // Primarna akcija – navigacija do pina
  const gmapsDir = `https://www.google.com/maps/dir/?api=1&destination=${pos.lat},${pos.lng}`;

  // Telefon (marker > global cfg)
  const phoneRaw = (m.phone || cfg.phone || "").trim();
  const phoneTel = phoneRaw.replace(/\s+/g, ""); // "tel:" ne voli razmake

  // HTML (Schema + logo + akcije)
  const html = `
    <div class="nn-iw" itemscope itemtype="https://schema.org/LocalBusiness">
      <div class="nn-iw__head">
        ${cfg.logoUrl ? `<img class="nn-iw__brand" src="${cfg.logoUrl}" alt="NN Rent a Car" loading="lazy" decoding="async">` : ``}
        ${m.title ? `<h3 class="nn-iw__title" itemprop="name">${m.title}</h3>` : ``}
      </div>

      ${m.info ? `<p class="nn-iw__desc" itemprop="description">${m.info}</p>` : ``}

      <div class="nn-iw__actions">
        <a class="nn-iw__btn nn-iw__btn--primary"
           href="${gmapsDir}" target="_blank" rel="noopener nofollow"
           aria-label="Navigacija do lokacije">
          Do lokacije
        </a>

        ${
          phoneTel
            ? `
          <a class="nn-iw__btn"
             href="tel:${phoneTel}"
             aria-label="Pozovite NN Rent a Car">
            Pozovi
          </a>`
            : ``
        }
      </div>

      <div class="nn-iw__meta" hidden>
        <span itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
          <meta itemprop="addressLocality" content="Beograd">
          <meta itemprop="addressCountry"  content="RS">
        </span>
        <meta itemprop="openingHours" content="Mo-Su 00:00-24:00">
        ${phoneTel ? `<meta itemprop="telephone" content="${phoneRaw}">` : ``}
        ${m.url ? `<meta itemprop="url" content="${m.url}">` : ``}
      </div>
    </div>
  `;

  adv.addListener("gmp-click", () => {
    info.setContent(html);
    info.open({ map, anchor: adv });
  });
});



    if (markers.length > 1) map.fitBounds(bounds, 40);
  }

  // Lazy init kad mapa uđe u viewport (i mali fallback)
  const start = () => init().catch(() => {});
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((ents, obs) => {
      if (ents.some((e) => e.isIntersecting)) {
        obs.disconnect();
        start();
      }
    }, { rootMargin: "150px" });
    io.observe(el);
    setTimeout(start, 2000);
  } else {
    start();
  }
})();
